
import authService from '../services/authenticationservice'
import Vue from 'vue'
import Router from 'vue-router'
import menuModule from 'vuex-store/modules/menu'
import Global from '../services/globalservice'
Vue.use(Router)

const router = new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'is-active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      name: 'Login',
      path: '/login',
      component: require('../views/login/index')
    },
    {
      name: 'Forgot Password',
      path: '/forgotPassword',
      component: require('../views/login/ForgotPassword')
    },
    {
      name: 'Reset Password',
      path: '/resetPassword/:token',
      component: require('../views/login/ResetPassword')
    },
    {
      path: '/',
      component: require('../views/Dash'),
      children: [
        {
          name: 'Home',
          path: 'home',
          alias: '',
          component: require('../views/Home'),
          meta: {
            roles: Global.ALL_ROLE
          }
        },
        {
          name: 'Permission Deny',
          path: 'permissionDeny',
          component: require('../views/error/PermissionDeny'),
          meta: {
            roles: Global.ALL_ROLE
          }
        },
        {
          name: '404 Not Found',
          path: 'notFound',
          component: require('../views/error/404NotFound'),
          meta: {
            roles: Global.ALL_ROLE
          }
        },
        {
          name: 'Preview Timesheet',
          path: '/timesheet/preview/:month/:year/:id',
          component: require('../views/timesheet/Preview'),
          meta: {
            roles: Global.ALL_ROLE
          }
          
        },
        {
          name: 'Confirm Password',
          path: '/confirmPassword',
          component: require('../views/login/ConfirmPassword'),
          meta: {
            roles: Global.ALL_ROLE
          }
        },
        ...generateRoutesFromMenu(menuModule.state.items)

      ]
      // beforeEnter: function (to, from, next) {
      //   authService.requireAuth(to, from, next)
      // }
    },
    {
      path: '*',
      redirect: '/notFound'
    }
  ]
})

router.beforeEach((to, from, next) => {
  authService.requireAuth(to, from, next)
})

// Menu should have 2 levels.
function generateRoutesFromMenu (menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path) {
      routes.push(item)
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes)
    }
  }
  return routes
}

export default router



// WEBPACK FOOTER //
// ./client/router/index.js